<template>
    <page-shell title="Experiences">
        <div v-if="!loading" class="experiences">
            <el-table @row-click="openExperience" :data="experiences" height="calc(100vh - 300px)" width="100%"
                :default-sort="{ prop: 'date', order: 'descending' }">
                    <el-table-column prop="name" label="Name" sortable>
                    </el-table-column>
                    <el-table-column prop="code" label="Code" sortable>
                    </el-table-column>
                    <el-table-column prop="duration" label="Duration" sortable>
                    </el-table-column>
                    <el-table-column prop="flexible" label="Flexible" sortable>
                        <template slot-scope="scope">
                            <span v-if="scope.row.flexible">Yes</span>
                            <span v-else>No</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="For" :filters="[{text: 'XCube', value: 'xcube'}, {text: 'XPod', value: 'xpod'}, {text: 'XKiosk', value: 'xkiosk'}, {text: 'XTend', value: 'xtend'}]"
                        :filter-method="filterFor">
                        <template slot-scope="scope">
                            <span class="hub-tags">
                                <el-tag v-if="scope.row.application?.type_for_xpod || scope.row.flexible" disable-transitions>XPOD</el-tag>
                                <el-tag v-if="scope.row.application?.type_for_xkiosk || scope.row.flexible" disable-transitions>XKIOSK</el-tag>
                                <el-tag v-if="scope.row.application?.type_for_xcube || scope.row.flexible" disable-transitions>XCUBE</el-tag>
                                <el-tag v-if="scope.row.application?.type_for_xtend || scope.row.flexible" disable-transitions>XTEND</el-tag>
                            </span>
                        </template>
                    </el-table-column>
            </el-table>
        </div>
        <spinner :loading="loading" text="Loading experiences..."></spinner>
    </page-shell>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { getExperiencesSimple } from "../../api/graphql/experiences";
import PageShell from "../shared/PageShell.vue";
import Spinner from "../shared/Spinner.vue";
import { useRouter } from "vue-router/composables";

const router = useRouter();

const experiences = ref([]);
const loading = ref(false);

const filterFor = (value, row) => {
    return row.flexible || row.application[`type_for_${value}`];
};

const openExperience = (row) => {
    router.push({ name: "experience", params: { id: row.id } });
};

onMounted(async () => {
    loading.value = true;
    experiences.value = await getExperiencesSimple();
    loading.value = false;
});
</script>

<style scoped lang="scss">
.experiences {
    width: 100%;
    min-width: 0;
}
</style>